import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import {rolesToGrouped} from './permissions';
// import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.ADMIN_UINFO,
  mutations: {
    init() {
      return {
        id: null,
        external_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password: '',
        status: '',
        type: '',
        groups: [],
        roles: [],
        pendingRole: null,
        pendingRoles: [],
        deletedRoleIds: [],
        permissions: [],
        profile: {},
        is_third_party_connected: false,
        managed_by: null,
        is_root_admin: false,
        learning_assistant_status: 'disabled',
      };
    },
    setInfo(subState, {id, external_id, first_name, last_name, email, phone, password, status, type, groups, roles, permissions, profile, learning_assistant_status, is_third_party_connected, managed_by, is_root_admin}) { // eslint-disable-line
      return Object.assign({}, subState, {
        id: id || null,
        external_id: external_id || '', // eslint-disable-line
        first_name: first_name || '', // eslint-disable-line
        last_name: last_name || '', // eslint-disable-line
        email: email || '',
        phone: phone || '',
        password: password || '',
        status: status || '',
        type: type || '',
        groups: groups || [], // eslint-disable-line
        roles: roles || [],
        permissions: permissions || [],
        profile: profile || {},
        is_third_party_connected,
        managed_by,
        is_root_admin,
        learning_assistant_status,
      });
    },
    setExternalId(subState, externalId) {
      return Object.assign({}, subState, {externalId});
    },
    setProfile(subState, profile) {
      return Object.assign({}, subState, {
        profile
      });
    },
    setPendingRoles(subState, pendingRole) {
      return Object.assign({}, subState, {
        pendingRoles: [
          ...subState.pendingRoles,
          pendingRole
        ]
      });
    },
    createRoles(subState, permissions) {
      const index = permissions.index;
      delete permissions.index;
      if (subState.pendingRoles[index]) {
        const pendingRoles = subState.pendingRoles.slice();
        pendingRoles[index] = Object.assign({}, pendingRoles[index], permissions);
        return Object.assign({}, subState, {pendingRoles});
      } else {
        return Object.assign({}, subState, {
          pendingRoles: [
            ...subState.pendingRoles,
            permissions
          ]
        });
      }
    },
    removeRole(subState, roleId) {
      const index = subState.roles.findIndex((role) => role.id === roleId);
      if (index > -1) {
        return Object.assign({}, subState, {
          roles: [
            ...subState.roles.slice(0, index),
            ...subState.roles.slice(index + 1)
          ],
          deletedRoleIds: [
            ...subState.deletedRoleIds,
            roleId
          ]
        });
      }

      return subState;
    },
    removeNewRole(subState, index) {
      return Object.assign({}, subState, {
        pendingRoles: [
          ...subState.pendingRoles.slice(0, index),
          ...subState.pendingRoles.slice(index + 1)
        ]
      });
    },
  },
  decorators: [
    (nextState) => { // $roles
      const state = storeInstance.getState();
      const subState = state[sdoNs.ADMIN_UINFO];
      const nextSubState = nextState[sdoNs.ADMIN_UINFO];

      if (typeof nextSubState.$roles === 'undefined' ||
        nextSubState.roles !== subState.roles) {
        const $roles = [];
        for (let i = 0; i < nextSubState.roles.length; i++) {
          const role = nextSubState.roles[i];
          const accessData = rolesToGrouped(role.access_data);
          const group = nextSubState.groups?.find((item) => item.id === role.group_id);
          let breadcrumbs = '';
          // group will only be empty if an admin is created without a role
          if (group) {
            breadcrumbs = [...group.parent_names || [], group.name].join(' > ');
            $roles.push({
              ...role,
              roles: accessData,
              group,
              breadcrumbs
            });
          }
        }
        nextState = deepAssign(nextState, sdoNs.ADMIN_UINFO, {$roles});
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
